import { LabelView } from "../../../Orders/GenerateShipment/LabelView"
import { jsPDF } from 'jspdf'
import JsBarcode from 'jsbarcode'
import { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"

export const GenerateTemplateLabel = ({
    groupingCode = '',
    templateName = '',
    onSuccess = () => {},
    onCancel = () => {},
}) => {
    const { i18n } = useTranslation()
    const [path, setPath] = useState(null)

    useEffect(() => {
        if (!groupingCode) return

        let pdfUrl = null
        try {
            const pdf = new jsPDF({
                orientation: 'portrait',
                unit: 'mm',
                format: [76, 102]
            })

            let yPosition = 10

            const addCenteredText = (text, fontSize, y, bold = false) => {
                pdf.setFontSize(fontSize)
                pdf.setFont('helvetica', bold ? 'bold' : 'normal')
                pdf.text(text, pdf.internal.pageSize.getWidth() / 2, y, { align: 'center' })
            }

            const addBarcode = (value, y) => {
                const canvas = document.createElement('canvas')
                JsBarcode(canvas, value, { format: "CODE128" })

                const barcodeImage = canvas.toDataURL('image/png')
                const imgProps = pdf.getImageProperties(barcodeImage)

                const pdfWidth = pdf.internal.pageSize.getWidth()
                const imgWidth = 70
                const imgHeight = (imgProps.height * imgWidth) / imgProps.width
                const x = (pdfWidth - imgWidth) / 2

                pdf.addImage(barcodeImage, 'PNG', x, y, imgWidth, imgHeight)
            }

            addCenteredText(i18n.t('container_templates.editor.grouping_code') + ':', 14, yPosition, true)
            yPosition += 8

            if (templateName) {
                addCenteredText(templateName, 12, yPosition, false)
                yPosition += 8
            }

            addBarcode(groupingCode, yPosition)

            const pdfBlob = pdf.output('blob')
            pdfUrl = URL.createObjectURL(pdfBlob)
            setPath(pdfUrl)
        } catch (error) {
            console.error("Error generating PDF:", error)
        }

        return () => {
            if (pdfUrl) URL.revokeObjectURL(pdfUrl)
        }
    }, [groupingCode, templateName, i18n])

    return (
        <LabelView
            title={i18n.t('container_templates.print_label')}
            type={"label"}
            file_path={path}
            is_replenishment_label={true}
            onCancel={() => onCancel()}
            onPrint={() => onSuccess()}
        />
    )
}
